import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { filter, map, Observable, take } from 'rxjs';
import { UserState } from '../../user-management/state/user-management.state';
import { IUser, Roles } from '@cod-monorepo/interfaces';

@Injectable({
    providedIn: 'root'
})
export class AdminGuard {
    user$: Observable<IUser | undefined> = inject(Store).select(UserState.user);
    constructor(private router: Router) {}

    public canLoad(): Observable<boolean> {
        return this.user$.pipe(
            filter(user => !!user),
            take(1),
            map(user => {
                const allowedRoles = [Roles.ADMIN];
                if (allowedRoles.some(role => user.roles?.includes(role))) {
                    return true;
                } else {
                    void this.router.navigate(['/auth/unauthorized']);
                    return false;
                }
            })
        );
    }
}

export const canActivateAdmin: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    adminGuard = inject(AdminGuard)
) => adminGuard.canLoad();
